<template>
    <div
        class="progress-bar"
        :style="{ 'grid-template-columns': `repeat(${totalSteps}, 1fr)` }"
    >
        <div
            class="step"
            :class="{ 'step--completed': step <= stepsCompleted }"
            v-for="step in totalSteps"
            :key="step"
        ></div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            totalSteps: "menu/getTotalProgressSteps",
            stepsCompleted: "menu/getCurrentProgressStep",
        }),
    },
};
</script>

<style lang="scss" scoped>
.progress-bar {
    width: 100%;
    height: 4px;
    position: fixed;
    z-index: 101;
    top: 60px;
    display: grid;
    grid-gap: 2px;
    .step {
        transition: background-color 0.8s ease-out;
        background-color: #efefef;
        &--completed {
            background-color: #f2c0de;
        }
    }
}
</style>
